import {AlertTypes} from "../../../../utils/alert.utils";

// Converted from makeStyles to simple style object
const styles = {
    paper: {
        marginTop: "64px",
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
    },
    form: {
        width: '100%',
        marginTop: "8px",
    },
    submit: {
        margin: "24px 0 16px",
    },
    [AlertTypes.SUCCESS]: {
        backgroundColor: '#4caf50', // MUI success.main default
    },
    [String(AlertTypes.FAILURE)]: {
        backgroundColor: '#f44336', // MUI error.main default
    },
    text: {
        color: "white",
        padding: "8px"
    },
};

const useStyles = () => styles;

export default useStyles;
